import React, { Component } from 'react'
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from 'redux'
// import {
//     Dropdown,
//     DropdownToggle
// } from 'reactstrap';
import has from 'mout/object/has'
import { setIndicator, changeSelectedOption } from '../../redux/modules/assessmentIndicator'
import { selectedYear } from '../../redux/modules/users'
import getSchoolYear from '../../helpers/getSchoolYear'
import { db } from "../../config/firebaseconfig";
import { assessment } from '../../redux/modules/assessment';
import { Col, Alert } from 'reactstrap'
const queryString = require("query-string");

class HeaderActiveYearIndicatior extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dropdownOpen: false,
      selectedValue: null,
      compareSelectedValue: null,
      compareSelectOptions: null,
      noDataMsg: false
    }
  }

  // toggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });

  componentDidMount() {
    // const year = new Date(getSchoolYear().timeStamp).getFullYear();
    // const option = [{ value: getSchoolYear().year, label: `School Year: [${year}-${year + 1}]` }]
    // this.props.dispatch(setIndicator({
    //   selectOptions: option,
    //   defaultValue: option[0]
    // }))
    this.props.dispatch(selectedYear(getSchoolYear().year));
  }

  handleChange = (e) => {
    if (e.value === 'compare') {

      this.initCompareSelector();
    } else if (e.value === 'removeCompare') {
      this.setState({ compareSelectOptions: null, compareSelectedValue: null });
      this.resetCompareMode();
    } else {
      this.setState({ selectedValue: e })
      this.props.dispatch(changeSelectedOption(e))
      this.changeActiveYear(e.year, 'yearChange');
    }
  }

  handleCompareChange = (e) => {
    if (e.value === 'removeCompare') {
      this.setState({ compareSelectOptions: null, compareSelectedValue: null });
      this.resetCompareMode();
    } else if (e.value !== '') {
      if (e.gua) {
        this.setCompareData(e)
      } else {
        db.collection('userAssessments').doc(e.userAssessmentId).get()
          .then((assessment) => {
            const userAssessment = assessment.data()
            this.setCompareData(e, userAssessment)
          })
      }

    } else {
      this.setState({ compareSelectedValue: e })
    }
  }

  initCompareSelector = () => {
    // const { match, location, licenses } = this.props;
    const { assessmentIndicator } = this.props.st;
    // const { selectedValue } = this.state;

    const compareOptions = assessmentIndicator.selectOptions.filter(assessment =>
      assessment.value !== assessmentIndicator.selectedOption.value
    )

    if (compareOptions.length) {
      this.setState({ compareSelectOptions: compareOptions });
      this.props.setCompareMode();
    } else {
      this.setState({ noDataMsg: true })
      setTimeout(() => { this.setState({ noDataMsg: false }) }, 2000)
    }

  }

  setCompareData = (selectObject, userAssessment) => {
    if (userAssessment) this.props.setCumpareAssismentData(userAssessment)

    this.props.setCompareAssismentId(selectObject.testId)

    this.props.setCompareAssismentName(selectObject.shortName)

    this.changeActiveYear(selectObject.year, 'compareYearChange');
    this.setState({ compareSelectedValue: selectObject })

  }

  changeActiveYear = (year, action) => {
    if (action === 'compareYearChange') {
      this.props.setCompareGUAYear(year);
    }
    if (action === 'yearChange')
      this.props.dispatch(selectedYear(year));
  }
  resetCompareMode = () => {
    this.props.unsetCompareMode();
    this.props.setCumpareAssismentData({});
    this.props.setCompareAssismentId('')
    this.props.setCompareAssismentName('')
    this.props.setCompareGUAYear('');

    let swap = this.props.swap;
    if (swap) this.props.setSwapStatus(!swap);
  }
  swapAssignment = () => {
    let swap = this.props.swap;
    this.props.setSwapStatus(!swap);
  }

  componentDidUpdate(prevProps) {
    const { assessmentIndicator } = this.props.st;
    const { selectedValue } = this.state;
    const { isCompare, location, history, match } = this.props
    const { selectedOption, selectOptions } = assessmentIndicator

    if (prevProps.st.assessmentIndicator.selectedOption !== selectedOption && selectedOption) {

      if (has(selectedOption, 'testId')) {

        const yearChangeCheck =
          Math.max(...selectOptions.map(option =>
            Number(option.year.split('sy')[1]))) === Number(getSchoolYear().year.split('sy')[1])

        if (!yearChangeCheck) return

        const { year, userAssessmentId, gua, student, testId } = selectedOption;

        const qs = queryString.parse(location.search);

        if (location.pathname.indexOf('/assessment/dashboard') > -1) {

          if (has(qs, 's')) {
            const newQs = {
              ...qs,
              s: selectedOption.student,
              y: year
            };
            const query = queryString.stringify(newQs);
            const path = `/assessment/dashboard/${testId}?${query}`
            history.push(path)

          } else if (has(qs, 'gua')) {
            const newQs = {
              gua: gua,
              y: year
            };
            const query = queryString.stringify(newQs);
            const path = `/assessment/dashboard/${testId}?${query}`
            history.push(path)

          } else {
            history.push(`/assessment/dashboard/${testId}?y=${year}`)
          }
        }

        if (location.pathname.indexOf('/assessment/reports') > -1) {
          const subtestId = location.pathname.split('/')[4]
          if (has(qs, 's')) {

            const newQs = {
              a: testId,
              g: true,
              s: student,
              y: year
            };

            const query = queryString.stringify(newQs);
            history.push(`?${query}`)

          } else if (has(qs, 'g')) {

            const newQs = {
              g: true,
              a: testId,
              y: year
            }

            const query = queryString.stringify(newQs);
            history.push(`/assessment/reports/${gua}/${subtestId}?${query}`)

          } else {
            history.push(`/assessment/reports/${userAssessmentId}/${subtestId}?y=${year}`)
          }
        }

        if (location.pathname.indexOf('/assessment/testing') > -1) {

          const subtestId = location.pathname.split('/')[4]

          if (has(qs, 's')) {

            const newQs = {
              ...qs,
              a: testId,
              s: student,
              y: year
            };

            const query = queryString.stringify(newQs);
            history.push(`?${query}`)

          } else if (has(qs, 'g')) {

            const newQs = {
              ...qs,
              a: testId,
              y: year
            }

            const query = queryString.stringify(newQs);
            history.push(`/assessment/testing/${gua}/${subtestId}?${query}`)

          } else {
            if (has(qs, 'item')) {
              const newQs = {
                ...qs,
                y: year
              }
              const query = queryString.stringify(newQs);
              history.push(`/assessment/testing/${userAssessmentId}/${subtestId}?${query}`)
            }
          }

        }
        this.props.setCurrentAssismentId(testId)
        this.props.setCurrentAssismentName(selectedOption.shortName)

        if (isCompare) {
          const compareOptions = assessmentIndicator.selectOptions.filter(assessment =>
            assessment.value !== assessmentIndicator.selectedOption.value
          )
          // this.props.setCumpareAssismentData({});
          // this.props.setCompareAssismentId('')
          // this.props.setCompareAssismentName('')
          // this.props.setCompareGUAYear('');

          // { value: '', label: 'Select an Assessment' }
          const { compareSelectedValue } = this.state;
          let currentOption;

          if (compareSelectedValue && has(compareSelectedValue, 'testId')) {
            currentOption = compareOptions.filter(option =>
              option.year === compareSelectedValue.year &&
              option.testId === compareSelectedValue.testId)[0]
          }

          if (!currentOption) currentOption = compareOptions[0]

          if (compareOptions.length) {
            this.setState({
              compareSelectedValue: compareSelectedValue ? currentOption : null,
              compareSelectOptions: compareOptions
            });
            compareSelectedValue ? this.handleCompareChange(currentOption) : false
          } else {
            this.setState({ noDataMsg: true })
            setTimeout(() => { this.setState({ noDataMsg: false }) }, 2000)
          }
        }
      }
    }

    if (prevProps.isCompare !== isCompare && isCompare == false) {
      this.setState({
        compareSelectedValue: null,
        compareSelectOptions: null
      })
    }

  }
  render() {
    //styles for selector component
    const colourStyles = {
      control: styles => ({
        ...styles,
        backgroundColor: '#ffffff00',
        borderWidth: 'none',
        borderStyle: 'none',
        borderBottom: '1px solid #fff',
        borderRadius: 0,
        cursor: 'pointer',
        boxShadow: 'none',
        '&:hover': false
      }),

      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          backgroundColor: isSelected ? '#029e8d' : '#fff',
          color: isSelected ? '#fff' : '#000',
          '&:hover': { backgroundColor: '#00C1AB', color: '#fff' }
        };
      },
      placeholder: styles => ({ color: '#fff' }),
      singleValue: styles => ({ color: '#fff', fontWeight: 600 })

    };
    const { assessmentIndicator } = this.props.st;
    const { licenses, location, swap, isCompare } = this.props;
    const { selectedValue, compareSelectedValue, compareSelectOptions, noDataMsg } = this.state;

    let showCompareOption = '';
    const removeCompare = { value: 'removeCompare', label: 'Remove Comparison Test' }
    if (location.pathname.indexOf('/assessment') > -1 && licenses.userlicenses.length && !isCompare) {
      showCompareOption = { value: 'compare', label: 'Show Comparison With' };
    }

    let fa_class_1 = 'left'
    let fa_class_2 = 'right'
    if (swap) {
      fa_class_1 = 'right'
      fa_class_2 = 'left'

    }
    const currentAssessmentSelect = assessmentIndicator.selectedOption ? (has(assessmentIndicator, 'defaultValue') &&
      Object.getOwnPropertyNames(assessmentIndicator.selectedOption).length !== 0
      && <Select className='select-dropdown'
        value={assessmentIndicator.selectedOption}

        options={
          isCompare && swap && compareSelectedValue ?
           [...assessmentIndicator.selectOptions, removeCompare]
            .filter(option => option.value !== compareSelectedValue.value) :
             isCompare && swap ? [assessmentIndicator.selectedOption, removeCompare] :
              isCompare && compareSelectedValue ? [...assessmentIndicator.selectOptions]
               .filter(option => option.value !== compareSelectedValue.value) :
                isCompare ? [...assessmentIndicator.selectOptions] :
                  showCompareOption ? [...assessmentIndicator.selectOptions, showCompareOption] : 
                    [...assessmentIndicator.selectOptions]
                  }

        styles={colourStyles}
        onChange={this.handleChange}
      />) : null;

    const compareAssessmentSelect = (isCompare &&
      <Select className='select-dropdown'
        placeholder={'Select an Assessment'}
        value={compareSelectedValue}
        options={
          swap ? [...compareSelectOptions]
            .filter(option => option.value !== assessmentIndicator.selectedOption.value) :
              [...compareSelectOptions, removeCompare]
                .filter(option => option.value !== assessmentIndicator.selectedOption.value)
              }
        styles={colourStyles}
        onChange={this.handleCompareChange}
      />);
    return (
      <div className='header-active-year-indicator'>
        {swap ? compareAssessmentSelect : currentAssessmentSelect}

        {isCompare &&
          <div className="compareVs" onClick={this.swapAssignment}>
            <i style={{ display: 'block', color: 'white', margin: '0 0 -8px 0' }} className={`fa fa-long-arrow-${fa_class_1}`}></i>
            {/* <span style={{ fontSize: '18px', color: '#F1F7F5', display: 'block', height: '19px' }}>vs</span> */}
            <i className={`fa fa-long-arrow-${fa_class_2}`} style={{ display: 'block', color: 'white' }} ></i>
          </div>
        }

        {noDataMsg ? <Alert style={{ display: 'inline-block', margin: '1px 0 0 15px' }} color='warning'>No Records found</Alert> : null}
        {swap ? currentAssessmentSelect : compareAssessmentSelect}


      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...state,
  currentAssismentId: state.assessment.currentAssismentId,
  compareAssismentId: state.assessment.compareAssismentId,
  setCurrentAssismentId: state.assessment.setCurrentAssismentId,
  setCompareAssismentId: state.assessment.setCompareAssismentId,
  setCompareMode: state.assessment.setCompareMode,
  isCompare: state.assessment.isCompare,
  setSwapStatus: state.assessment.setSwapStatus,
  swap: state.assessment.isSwap,
  currentAssismentName: state.assessment.currentAssismentName,
  compareAssismentName: state.assessment.compareAssismentName,
  compareAssismentData: state.assessment.compareAssismentData
})

const mapDispatchToProps = dispatch => {
  return {
    setCurrentAssismentId: currentAssismentId => {
      dispatch({
        type: "SET_CURRENT_ASSISMENT_ID",
        value: currentAssismentId
      });
    },
    setSwapStatus: status => {
      dispatch({
        type: "SET_SWAP_STATUS",
        value: status
      });
    },
    setCompareAssismentId: compareAssismentId => {
      dispatch({
        type: "SET_COMPARE_ASSISMENT_ID",
        value: compareAssismentId
      });
    },
    setCompareAssismentName: compareAssismentName => {
      dispatch({
        type: "SET_COMPARE_ASSISMENT_NAME",
        value: compareAssismentName
      });
    },
    setCurrentAssismentName: currentAssismentName => {
      dispatch({
        type: "SET_CURRENT_ASSISMENT_NAME",
        value: currentAssismentName
      });
    },
    setCumpareAssismentData: compareAssismentData => {
      dispatch({
        type: "SET_COMPARE_ASSISMENT_DATA",
        value: compareAssismentData
      });
    },
    setCompareMode: () => {
      dispatch({
        type: "SET_COMPARE_MODE",

      });
    },
    unsetCompareMode: () => {
      dispatch({
        type: "UNSET_COMPARE_MODE",

      });
    },
    setCompareGUAYear: guaYear => {
      dispatch({
        type: "SET_COMPARE_GUA_YEAR",
        value: guaYear
      });
    },
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderActiveYearIndicatior)


// WEBPACK FOOTER //
// ./src/components/Header/HeaderActiveYearIndicator.js